import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';
import { setTextBrightness } from './useColor';

export const listTags = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tag`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getTag = async (tagId) => {
    let res = {},
        searchEndpoint = '/v2/tag';

    if (tagId !== '0') {
        res =
            (await r({
                endpoint: `${keeper('apiUrl')}/v2/tag/${tagId}`,
                sessionToken: keeper('sessionToken'),
                method: 'get',
            })) || {};
    }

    if (Object.keys(res).length === 0) {
        res = await normalizeBySchema(searchEndpoint, 'post', res);
    }

    return res;
};

export const saveTag = async (tagId, data, saving = {}) => {
    let method = 'put',
        endpoint = `${keeper('apiUrl')}/v2/tag/${tagId}`,
        searchEndpoint = '/v2/tag/{tagId}',
        defaultTypeName = 'TagDto';

    if (tagId === '0') {
        method = 'post';
        searchEndpoint = '/v2/tag';
        endpoint = `${keeper('apiUrl')}/v2/tag`;
        // THIS WILL LIKELY CHANGE defaultTypeName = 'TagDto';
    }

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;

    if (Object.keys(data).includes('isValid')) {
        dataModel.isValid = data.isValid;
    }

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });

    saving.active = false;
    return res;
};

export const deactivateTag = async (tagId) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/tag/${tagId}`,
        sessionToken: keeper('sessionToken'),
        method: 'delete',
    });
    return res;
};

export const toSimpleTagObject = (tags = {}) => {
    const res = [];
    tags.forEach((tag) => {
        res.push({
            name: tag.name,
            tagId: tag.tagId,
            tagReferenceId: tag.tagReferenceId,
            templateId: tag.templateId,
        });
    });
    return res;
};

export const defaultRemoveTag = (tag, tags) => {
    const index = tags.indexOf(tag);
    tags.splice(index, 1);
};

export const defaultAddTag = (input, tags, values) => {
    const index = tags.indexOf(input);
    if (index < 0) {
        tags.push({ tag: input });
    }
    values.inputTag = '';
    values.showSuggestions = false;
};

export const getTagByName = (tagName, allTags) => {
    return allTags.find((tag) => tag.name === tagName);
};

export const getTagStyles = (tag) => {
    const styles = {
        backgroundColor: tag?.color || '#000000',
        borderColor: tag?.color || '#000000',
        color: setTextBrightness(tag?.color || '#000000', true),
    };
    return `color: ${styles.color}; background-color: ${styles.backgroundColor}; border-color: ${styles.borderColor};`;
};

export const useTags = () => {
    return {
        listTags: listTags,
        getTag: getTag,
        saveTag: saveTag,
        deactivateTag: deactivateTag,
        toSimpleTagObject: toSimpleTagObject,
        defaultRemoveTag: defaultRemoveTag,
        defaultAddTag: defaultAddTag,
        getTagByName: getTagByName,
        getTagStyles: getTagStyles,
    };
};

export default useTags;
